import React, { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { Provider } from "react-redux";
import { store } from "./store/store";
import AppRoutes from "./AppRoutes";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    // Block zoom via keyboard keys
    const handleKeyDown = (event: KeyboardEvent) => {
      // Log the key being pressed
      //console.log(`Key pressed: ${event.key}`);

      // Check if the zoom combination is pressed (Ctrl/Cmd + +, Ctrl/Cmd + -, or Ctrl/Cmd + 0)
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "=" || event.key === "-" || event.key === "0")
      ) {
        event.preventDefault(); // Prevent the zoom behavior
        console.log(`Zoom event prevented: ${event.key}`);
      }
    };

    // Block zoom via mouse scroll
    const handleWheel = (event: WheelEvent) => {
      // Check if the Ctrl or Cmd key is pressed and the user is scrolling
      if (event.ctrlKey) {
        event.preventDefault(); // Prevent zoom on scroll
        console.log("Zoom event prevented by mouse scroll + Ctrl");
      }
    };

    // Add event listener for keydown to block zoom using keyboard
    window.addEventListener("keydown", handleKeyDown);

    // Add event listener for wheel to block zoom using mouse scroll + Ctrl
    window.addEventListener("wheel", handleWheel, { passive: false });

    // Clean up the event listeners on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <AppRoutes />
      </Provider>
      <ToastContainer position="bottom-right" autoClose={2000} />
    </ThemeProvider>
  );
}

export default App;
